import MSI from "./MSI.js";
import { mod10 } from "./checksums.js";
class MSI1010 extends MSI {
  constructor(data, options) {
    data += mod10(data);
    data += mod10(data);
    super(data, options);
  }
}
var stdin_default = MSI1010;
export {
  stdin_default as default
};
